import Order from "../components/order/order";

import WebpackerReact from "webpacker-react";
import "./translations";

I18n.locale = $('html').attr('lang');
WebpackerReact.setup({ Order });
